export default __webpack_public_path__ + "img/happy-vote.cf309b1.svg";